// Make React resilient to third-party DOM mutations from in-browser translators
// (Safari / Google Translate). They wrap text nodes in <font> tags, which later
// makes React's removeChild/insertBefore throw "The object can not be found here"
// / "The node to be removed is not a child of this node" and crash the whole app.
// See facebook/react#11538. This defensive patch no-ops on mismatched parents.
if (typeof Node === "function" && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    if (child.parentNode !== this) {
      return child;
    }
    return originalRemoveChild.apply(this, arguments);
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      return newNode;
    }
    return originalInsertBefore.apply(this, arguments);
  };

  const originalReplaceChild = Node.prototype.replaceChild;
  Node.prototype.replaceChild = function (newChild, oldChild) {
    if (oldChild && oldChild.parentNode !== this) {
      return oldChild;
    }
    return originalReplaceChild.apply(this, arguments);
  };
}
